import { useCurrentProfileSafe } from '@/contexts/ProfileContext';

/**
 * useWishlist - Hook for wishlist functionality
 * 
 * Now uses the centralized ProfileContext instead of making direct Supabase calls.
 * This eliminates redundant /auth/v1/user and /rest/v1/profiles requests.
 */
export const useWishlist = () => {
  const profileContext = useCurrentProfileSafe();

  // Return context values if available
  if (profileContext) {
    return {
      wishlist: profileContext.wishlist,
      toggleWishlist: profileContext.toggleWishlist,
      isInWishlist: profileContext.isInWishlist,
      loading: profileContext.wishlistLoading,
    };
  }

  // Fallback for components outside ProfileProvider (shouldn't happen normally)
  console.warn('[useWishlist] Used outside ProfileProvider, returning empty state');
  return {
    wishlist: [],
    toggleWishlist: async () => {},
    isInWishlist: () => false,
    loading: false,
  };
};
